module.exports = __webpack_public_path__ + "static/img/mini1.25aa3e95.png";